// Copyright 2025-2026 - Hewlett Packard Enterprise Company
import React, {
  createContext,
  useContext,
  useRef,
  useLayoutEffect,
} from 'react';
import { useLocation } from 'react-router-dom';

export const PreviousLocationContext = createContext(null);

export const PreviousLocationProvider = ({ children }) => {
  const { pathname } = useLocation();
  const previousLocation = useRef(null);

  useLayoutEffect(() => {
    previousLocation.current = pathname;
  }, [pathname]);

  return (
    <PreviousLocationContext.Provider value={previousLocation.current}>
      {children}
    </PreviousLocationContext.Provider>
  );
};

export const usePreviousLocation = () => useContext(PreviousLocationContext);

export default PreviousLocationProvider;
